define('SageDotCom/Components/Content/ToggleSwitcher',["jquery",
    "eventManager",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/DataLayer/Events/buttonClick",
    "SageDotCom/Utility/gatedContentHelper"],

    function ($, eventManager, tealium, buttonClickEvent, gatedContentHelper) {
        function ToggleSwitcher(scope, clickMessagesTransmitting) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });

            var toggleSwitcherElement = $('#sage-toggle-switcher-checkbox');

            function updateGatedContent() {
                gatedContentHelper.unLoadGatedContent(document.querySelector('body'));
                gatedContentHelper.loadGatedContent(document.querySelector('body'));
            }

            if (clickMessagesTransmitting.length) {
                toggleSwitcherElement.on("change",
                    function (e) {
                        e.preventDefault();
                        var messagetransmitting;
                        var toggleChecked = toggleSwitcherElement.is(':checked');
                        var toggleSwitcherWrapper = $(this).closest(".sage-toggle-switcher-wrapper");


                        if (toggleChecked) {
                            messagetransmitting = clickMessagesTransmitting[1];
                            toggleSwitcherWrapper.addClass("right-side");
                        } else {
                            messagetransmitting = clickMessagesTransmitting[0];
                            toggleSwitcherWrapper.removeClass("right-side");

                        }

                        clickMessagesTransmitting.forEach(function () {
                            eventManager.trigger(messagetransmitting, self);
                        });

                        setTimeout(updateGatedContent, 0);

                        var data = buttonClickEvent.GenerateEventMetadata(e.currentTarget);
                        tealium.event(data);

                        return !1;
                    });
            }
        }

        ToggleSwitcher.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ToggleSwitcher(args.scope, args.ClickMessagesTransmitting || []);
        };

        return ToggleSwitcher;
    });
